export default __webpack_public_path__ + "img/bg-tab1and2_nav1-fc266447.png";